import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NgProgressService {
  readonly loading$: Observable<boolean>;
  private readonly _loading$: Subject<boolean> = new Subject();

  constructor() {
    this.loading$ = this._loading$.asObservable();
  }

  startLoader(): void {
    this._loading$.next(true);
  }

  completeLoader(): void {
    this._loading$.next(false);
  }

  setLoader(isLoading: boolean): void {
    this._loading$.next(isLoading);
  }
}
